import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  styled,
} from '@mui/material'
import DateFormatter from '@/utilities/date-formatter'

interface ProvinceData {
  id: number
  dealerName: string
  name: string
  dateCreated: string
  dateModified: string
  sourceProvinceId: number
}

interface ViewProvinceModalProps {
  open: boolean
  onClose: () => void
  data: ProvinceData | null
}

export const ModalContainer = styled(Box)({
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  height: `calc(100% - 120px)`, // Adjust height for pagination
  flex: 1,
  overflow: 'auto',
  position: 'relative',
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f1f1f1',
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#555',
    },
  },
})

// this is actually view Branch Modal
const ViewProvinceModal = ({ open, onClose, data }: ViewProvinceModalProps) => {
  if (!data) return null

  const fields = [
    { label: 'ID', value: data.sourceProvinceId },
    { label: 'Name', value: data.dealerName },
    { label: 'Region', value: data.name },
    {
      label: 'Created Date',
      value: <DateFormatter dateString={data.dateCreated} />,
    },
    {
      label: 'Modified Date',
      value: <DateFormatter dateString={data.dateModified} />,
    },
    { label: 'Source Province ID', value: data.sourceProvinceId },
  ]

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Branches Details</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          {fields.map((field, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography
                variant="caption"
                component="div"
                sx={{
                  color: 'text.secondary',
                  mb: 0.5,
                }}
              >
                {field.label}
              </Typography>
              <Typography variant="body2">{field.value}</Typography>
              {index < fields.length - 1 && <Divider sx={{ mt: 2 }} />}
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ViewProvinceModal
